import { useMountEffect } from "@react-hookz/web";
import type { FunctionComponent } from "react";
import { useCallback, useState } from "react";

import { sendGA4Tracking } from "scmp-app/components/tracking/google-analytics-4/apis";

import GoogleIcon from "./icon-google.png";
import { Container, GoogleNewsButton, ImageGoogle, TextContent } from "./styles";

const GOOGLE_NEWS_URL = "https://www.google.com/preferences/source?q=scmp.com";

interface Props {
  articleId?: string;
  className?: string;
}

export const ArticleGoogleNewsButton: FunctionComponent<Props> = ({ articleId, className }) => {
  const [isVisible, setIsVisible] = useState(false);

  const isEnglishLanguage = () => {
    const language =
      (window.navigator as Navigator & { userLanguage?: string }).userLanguage ??
      window.navigator.language;
    return language.toLowerCase().startsWith("en");
  };

  const handleClick = useCallback(() => {
    if (articleId) {
      sendGA4Tracking({
        action: "click",
        category: "google",
        customized_parameters: {
          article_id: articleId,
          page_type: "article",
        },
        subcategory: "preferred_source",
      });
    }
    window.open(GOOGLE_NEWS_URL, "_blank", "noopener,noreferrer");
  }, [articleId]);

  useMountEffect(() => {
    setIsVisible(isEnglishLanguage());
  });

  return (
    <Container className={className}>
      {isVisible && (
        <GoogleNewsButton
          aria-label="Follow SCMP on Google News"
          onClick={handleClick}
          type="button"
        >
          <ImageGoogle alt="Google News Preferred Icon" src={GoogleIcon.src} />
          <TextContent>Make SCMP preferred on Google</TextContent>
        </GoogleNewsButton>
      )}
    </Container>
  );
};

ArticleGoogleNewsButton.displayName = "ArticleGoogleNewsButton";
